<template>
    <div class="container-fluid container-wrap col-sm-12 col-xs-12">
        <div class="row justify-content-center">
            <div class="col-sm-12 col-xs-12">
                    <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area"
                            >
                                <div>
                                    <h3>{{ $t('manu_acc_title') }}</h3>
                                    <h5>{{ $t('manu_acc_desc') }}</h5>
                                </div>
                            </div>
                            <!-- 「고객 지원을 위한 접근 허용」 동의(회사 관리자·지원 탭 아님만 보임, W6 C4) -->
                            <support-consent-card :company-manager="isCompanyManager" />
                            <div class="card-body px-0 pt-0 pb-2 table-with-search">
                                <div class="search-filter-container table-info-filter">
                                    <div class="search-filter-row">
                                        <div class="search-filter-title">
                                            검색어
                                        </div>
                                        <div class="search-filter-content">
                                            <div class="mobile-wrap">
                                                <a-select 
                                                    style="width: 100px"
                                                    size="small"
                                                    v-model:value="searchFilter"
                                                    @change="v => searchFilter = v"
                                                >
                                                    <a-select-option value="" selected>{{ $t('manu_acc_list_search_choose') }}</a-select-option>
                                                    <a-select-option value="name">{{ $t('manu_acc_list_search_name') }}</a-select-option>
                                                    <a-select-option value="deptName">{{ $t('manu_acc_list_search_dept') }}</a-select-option>
                                                    <a-select-option value="duty">{{ $t('manu_acc_list_search_duty') }}</a-select-option>
                                                    <a-select-option value="mobile">{{ $t('manu_acc_list_search_mobile') }}</a-select-option>
                                                    <a-select-option value="username">{{ $t('manu_acc_list_search_username') }}</a-select-option>
                                                </a-select>
                                                <a-input 
                                                    size="small"
                                                    style="width: 200px;"
                                                    v-model:value="condition"
                                                    @keyup.enter="enter()"
                                                    :placeholder="$t('common_searchfilter_placeholder')"
                                                >
                                                    <template #prefix>
                                                        <i
                                                            class="fa-regular fa-magnifying-glass"
                                                        />
                                                    </template>
                                                </a-input>
                                            </div>
                                            <div class="button-wrap">
                                                <a-button
                                                        class="black"
                                                        size="small"
                                                        @click="enter"
                                                >
                                                        {{ $t('certificatelist_search') }}
                                                </a-button>
                                                <a-button
                                                    @click="event => {
                                                    initSearchFilter()
                                                    enter()
                                                    }"
                                                    size="small"
                                                >
                                                    {{ $t('common_searchfilter_reset') }}
                                                </a-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12 table-info-filter">
                                    <div class="total-div">
                                    <p>
                                        {{ $t('common_total') }} <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>{{ $t('common_case') }}
                                    </p>
                                    </div>
                                    <div class="search-container">
                                    <a-select 
                                        style="width: 150px"
                                        v-model:value="rowsPerPage" 
                                        @change="handleRowsPerPage"
                                    >
                                        <a-select-option :value="10">10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                                        <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                                        <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                                    </a-select>
                                    <!-- 이용 내역(회사 관리자만, W6 C6) -->
                                    <a-button v-if="isCompanyManager" @click="$router.push('/audit-logs')">
                                        이용 내역 보기
                                    </a-button>
                                    <a-button
                                        v-if="visibleCreateAccountBtn"
                                        @click="openModal(modalType.create)"
                                        type="primary" 
                                    >
                                        <template #icon>
                                        <i class="fa-solid fa-plus"/>
                                        </template>
                                        {{ $t('manu_acc_add_person') }}
                                    </a-button>
                                    </div>
                                </div>
                                <!-- 회사 강제는 서티라이프 운영팀만 바꿈(U-20·D-79) → 관리자에게 상태만 표 위 안내 줄로 -->
                                <p v-if="isCompanyManager" class="two-factor-status">
                                    <i class="fa-solid fa-circle-info" />
                                    {{ companyPolicyText(twoFactorRequired) }}
                                </p>
                                <a-table 
                                    class="ant-table-striped"
                                    size="small"
                                    :columns="columns"
                                    :data-source="responseData"
                                    :pagination="false"
                                    :scroll="{ x: 'max-content' }"
                                    v-if="responseData.length > 0"
                                >
                                    <template #bodyCell="{ column, record }" />
                                </a-table>
                                <div class="no-result-container" v-else>
                                    <i class="fa-solid fa-exclamation-triangle" />
                                    <span>{{ computedNoResultMessage }} </span>
                                </div>
                            </div>
                            <pagination 
                                v-if="!$store.state.isLoading && responseData.length > 0"
                                :page-info="paginationData"
                                page-name="ManuAccList"
                                @change-page="paginationHandler"
                            />
                        </div>
                    </div>
            </div>
        </div>
    </div>
    <menu-modal
        :show-modal="modal.menu.show"
        @close-modal="closeModal(modalType.menu)"
        :username="modal.selectedItem.username"
    />
    <create-modal
        :show-modal="modal.create.show"
        @getAccountsList="getAccountsList"
        @close-modal="closeModal(modalType.create)"
    />
    <update-modal
        :show-modal="modal.update.show"
        @close-modal="closeModal(modalType.update)"
        @getAccountsList="getAccountsList"
        :id="modal.selectedItem._id ? modal.selectedItem._id : ''"
    />
</template>

<script>
import { getAccessToken, getProfile } from '@/utils/tokenStore';
    import { 
        convertDateTime, 
        oneBtnDialog, 
        confirmDialog, 
        twoBtnDialog,
        jwtDecoder, 
        formatCommaNumber,
        getPrivilegeInfoByName,
    } from '@/utils/utils';
    import NoResult from '@/views/components/NoResult.vue';
    import Pagination from '@/views/components/Pagination.vue';
    import MenuModal from './components/MenuModal.vue';
    import CreateModal from './components/CreateModal.vue';
    import UpdateModal from './components/UpdateModal.vue';
    import { modalType } from './enums/enums';
    import { phoneNumberFormatter } from '@/utils/utils';
    import { accountSecurityApi } from '@/apis/accountSecurity';
    import SupportConsentCard from '@/views/components/SupportConsentCard.vue';
    import { supportRowLabel } from '@/utils/supportConsent';
import { masterCheckUsername } from '@/utils/supportMaster';
    import {
        LOCKED_HINT,
        accountName,
        alreadyNotified,
        companyPolicyText,
        isResetProtected,
        resetConfirmText,
        resetErrorMessage,
        twoFactorCell,
    } from '@/utils/mfa';


    export default {
        name: 'ManuAccManage',
        components: {
            NoResult,
            Pagination,
            MenuModal,
            CreateModal,
            UpdateModal,
            SupportConsentCard,
        },
        computed: {
            /** 회사 단위 계정 자동 프로비저닝 (true면 수동 생성 버튼 숨김) */
            isAccountAutoProvisioned() {
                try {
                    const companyInfo = JSON.parse(getProfile('CompanyInfo') || 'null');
                    return companyInfo?.isAccountAutoProvisioned === true;
                } catch {
                    return false;
                }
            },
            visibleCreateAccountBtn() {
              return this.privilege.create && !this.isAccountAutoProvisioned;
            },
            /** privilege.update 만 — 회사명 하드코딩 제거 (DB privilege로 제어) */
            visibleUpdateAccountBtn() {
                return this.privilege.update;
            },
            /** privilege.delete 만 — username 하드코딩 제거 (DB privilege로 제어) */
            visibleDeleteAccountBtn() {
              return this.privilege.delete;
            },
            computedNoResultMessage() {
                if(this.calledApiTimes <= 1) {
                    return this.$i18n.t('noresult_search');
                } else {
                    return this.$i18n.t('noresult_search');
                }
            },
        },
        data() {
            return {
                formatCommaNumber,
                modalType,
                addItemPath: '/item/add',
                isInputFocused: false,

                // 목록 받아오는 변수
                responseData: [],
                calledApiTimes: 0,

                // 페이지네이션 관련 변수
                searchFilter: '',
                previousCondition: '',
                condition: '',

                listSize: 0,
                rowsPerPage: 10, 
                paginationData: {
                    currentPage: 1, 
                    totalPages: 0,
                },

                modal: {
                        selectedItem: '',
                        menu: {show: false,},
                        create: {show: false,},
                        update: {show: false,},
                },
                privilege: {
                    create: false,
                    read: true,
                    update: false,
                    delete: false,
                },
                // 회사 관리자만 「권한」 버튼·2차 인증 초기화·회사 강제 상태를 봄 (REQ-ACC-011)
                isCompanyManager: false,
                twoFactorRequired: false,
                columns:[
                    {
                        key: 'index', dataIndex: 'index', align: 'center', width: "4%",
                        customRender: ({text, record}) => {
                            return (
                                <div style="display: flex; " >
                                    {record.index}
                                </div>
                            )
                        },
                        title: ()=>{
                            return (
                            this.$t('itemslist_table_no')
                            )
                        }
                    },
                    {
                        key: 'deptName', dataIndex: 'deptName', align: 'center', width: "10%",
                        customRender: ({text, record}) => {
                            return (
                                <div style="display: flex; " >
                                    { record.deptName || '-' }
                                </div>
                            )
                        },
                        title: ()=>{
                            return (
                                this.$t('manu_acc_list_search_dept')
                            )
                        }
                    },
                    {
                        key: 'duty', dataIndex: 'duty', align: 'center', width: "10%",
                        customRender: ({text, record}) => {
                            return (
                                <div style="display: flex; " >
                                    { record.duty || '-' }
                                </div>
                            )
                        },
                        title: ()=>{
                            return (
                                this.$t('manu_acc_list_duty')
                            )
                        }
                    },
                    {
                        key: 'name', dataIndex: 'name', align: 'center', width: "10%",
                        // 로그인 잠김은 2차 인증과 따로(초기화로 안 풀림) 이름 옆 배지 + 설명
                        customRender: ({text, record}) => {
                            return (
                                <div class="name-cell" >
                                    { record.name || '-' }
                                    {supportRowLabel(record) && (
                                        <span class="tf-badge tf-badge--off">{supportRowLabel(record)}</span>
                                    )}
                                    {record.locked && (
                                        <a-tooltip title={LOCKED_HINT}>
                                            <span class="tf-badge tf-badge--locked" tabindex="0">로그인 잠김</span>
                                        </a-tooltip>
                                    )}
                                </div>
                            )
                        },
                        title: ()=>{
                            return (
                                this.$t('manu_acc_list_name')
                            )
                        }
                    },
                    {
                    key: 'username', dataIndex: 'username', align: 'center', width: "10%",
                        customRender: ({text, record}) => {
                            return (
                                <div style="display: flex; " >
                                    { record.username || '-' }
                                </div>
                            )
                        },
                        title: ()=>{
                            return (
                                this.$t('manu_acc_list_username')
                            )
                        }
                    },
                    {
                        key: 'mobile', dataIndex: 'mobile', align: 'center', width: "10%",
                        customRender: ({text, record}) => {
                            return (
                                <div style="display: flex; " >
                                    { phoneNumberFormatter(record.mobile) || '-' }
                                </div>
                            )
                        },
                        title: ()=>{
                            return (
                                this.$t('manu_acc_list_mobile')
                            )
                        }
                    },
                    {
                        // 표 폭을 줄이려고 켜짐/꺼짐 배지 아래 등록된 수단 이름만(가린 값은 같은 줄 휴대폰 번호와 겹침)
                        key: 'twoFactor', dataIndex: 'twoFactor', align: 'center', width: "10%",
                        customRender: ({record}) => {
                            const { on, methods, note } = twoFactorCell(record.twoFactor);
                            // 칸이 좁아(1280) 「본인이 끔」은 수단 이름과 따로 한 줄
                            return (
                                <div class="two-factor-cell">
                                    <span class={['tf-badge', on ? 'tf-badge--on' : 'tf-badge--off']}>{on ? '켜짐' : '꺼짐'}</span>
                                    {note && <span class="two-factor-methods">{note}</span>}
                                    {methods && <span class="two-factor-methods">{methods}</span>}
                                </div>
                            )
                        },
                        title: () => '2차 인증',
                    },
                    {
                        key: 'isFirstLogin', dataIndex: 'isFirstLogin', align: 'center', width: "10%",
                        customRender: ({text, record}) => {
                            return (
                                <div style="display: flex; " >
                                    { this.handleIsFirstLoginText(record.isFirstLogin) || '-' }
                                </div>
                            )
                        },
                        title: ()=>{
                            return (
                                this.$t('manu_acc_list_is_first_login')
                            )
                        }
                    },
                    {
                        key: 'isErp', dataIndex: 'isErp', align: 'center', width: "10%",
                        customRender: ({text, record}) => {
                            return (
                                <div style="display: flex; " >
                                    { this.handleIsErpText(record.isErp) || '-' }
                                </div>
                            )
                        },
                        title: ()=>{
                            return (
                                this.$t('manu_acc_list_is_erp')
                            )
                        }
                    },
                    {
                        key: 'createAt', dataIndex: 'createAt', align: 'center', width: "10%",
                        customRender: ({text, record}) => {
                            return (
                                <div class="date-cell" style="display: flex; " >
                                    { convertDateTime(record.createAt) }
                                </div>
                            )
                        },
                        title: ()=>{
                            return (
                                this.$t('manu_acc_list_create_at')
                            )
                        }
                    },
                ]
            };
        },
        async mounted() {
            await this.initScreen();
            const obj = {};
            obj.page = this.paginationData.currentPage;
            this.paginationHandler(obj);
            await this.getAccountsList();
        },
        methods: {
            async initScreen() {
                const [privileges, profile] = await Promise.all([this.getPrivilegesInfo(), this.getSecurityProfile()]);
                this.twoFactorRequired = profile?.mfa?.companyRequired === true;
                if(!privileges || !privileges.category || !Array.isArray(privileges.category)) return;

                this.privilege = await getPrivilegeInfoByName(privileges.category, '기타', '직원 계정 조회');
                // 회사 관리자 = 「직원 계정 조회」 쓰기 권한(U-12). 서버 판정을 쓰고, 필드가 없는 옛 서버면 같은 화면 권한으로
                this.isCompanyManager = profile?.isCompanyManager ?? this.privilege.create;
                this.setColumn();
            },
            async getSecurityProfile() {
                try {
                    return await accountSecurityApi.getProfile();
                } catch (error) {
                    console.log(error);
                    return null;
                }
            },
            isOwnAccount(record) {
                const companyInfo = JSON.parse(getProfile('CompanyInfo') || 'null');
                return !!record?.username && companyInfo?.accountInfo?.username === record.username;
            },
            companyPolicyText,
            // 휴대폰 분실 등: 직원의 휴대폰·이메일 수단을 지움(DELETE /accounts/:id/two-factor, design.md §6-2 B1')
            async handleResetTwoFactor(record) {
                const confirmed = await twoBtnDialog(
                    '2차 인증 초기화',
                    resetConfirmText(record, this.twoFactorRequired),
                    '초기화',
                    '취소',
                    { confirmStyle: 'danger', focusCancel: true }
                );
                if(!confirmed) return;

                try {
                    await accountSecurityApi.resetTwoFactor(record._id);
                    await oneBtnDialog('초기화 완료', `${accountName(record)}님의 2차 인증을 초기화했습니다.`, false);
                } catch (error) {
                    console.log(error);
                    // 국외 차단·2차 인증 확인 실패(503)는 axios 인터셉터가 이미 알렸고, 본인 확인 창을 스스로 닫았으면 실패가 아님
                    if(!alreadyNotified(error)) {
                        await oneBtnDialog('초기화 실패', resetErrorMessage(error) || error.response?.data?.message || '2차 인증을 초기화하지 못했습니다.', false);
                    }
                }
                await this.getAccountsList();
            },
            async getPrivilegesInfo() {
                const userId = JSON.parse(getProfile('CompanyInfo'))['accountInfo']['username'];
                const companyId = jwtDecoder(getAccessToken());
                if(!companyId) return;
                try {
                    if(!userId) return;
                    const response = await this.$apiInstance.get(`${process.env.VUE_APP_SERVERURL}/privileges/${userId}`)
                    const obj = { category: [], username: ''}
                    obj.username = this.$store.getters.getUserInfo.username;
                    if (response.status === 200 || response.status === 201) {
                        if(response.data.length === 0) {
                            return obj;
                        }
                        const newArray = response.data.categories.filter((item) => item.menu.length > 0);
                        obj.category = newArray;
                        return obj;
                    }
                } catch (error) {
                    console.log(error);
                    await oneBtnDialog('메뉴 로드 실패', '메뉴 로드에 실패했습니다.', false);
                }
            },
            initSearchFilter(){
                this.searchFilter = '';
                this.previousCondition = '';
                this.condition = '';
            },
            convertDateTime,
            setColumn() {
                const companyInfo = JSON.parse(getProfile('CompanyInfo'));
                // 「권한 관리」 칸 = 권한 버튼 + 「2차 인증 초기화」(따로 칸을 두면 1280 폭에서 수정·삭제가 밀려남, #14).
                // 초기화 못 하는 줄(자기 행 → 「내 계정 보안」, 서버가 보호한 대표·관리자 행 twoFactor.resetProtected, D-129)은 끈 버튼 + 이유 툴팁
                const resetButton = (record) => {
                    const blockedReason = this.isOwnAccount(record)
                        ? '본인 계정은 왼쪽 위 이름을 눌러 「내 계정 보안」에서 바꿉니다.'
                        : isResetProtected(record)
                            ? '대표·관리자 계정은 서티라이프 운영팀에 초기화를 요청하세요.'
                            : '';
                    const button = (
                        <a-button class="tf-reset-btn" disabled={!!blockedReason} onClick={() => this.handleResetTwoFactor(record)}>
                            2차 인증 초기화
                        </a-button>
                    );
                    return blockedReason
                        ? <a-tooltip title={blockedReason}><span class="tf-reset-wrap">{button}</span></a-tooltip>
                        : button;
                };
                // 권한 관리·수정·삭제는 오른쪽에 고정: 1280 폭에서 표가 넘쳐도 버튼은 늘 보이고 가운데 칸만 가로로 밀림(#14)
                const menuColumn = {
                    key: 'menu-button', dataIndex: 'menu-butto', align: 'center', fixed: 'right',
                    customRender: ({text, record}) => {
                        // 지원 계정 줄은 버튼 없음(서버도 403 SUPPORT_ACCOUNT_READONLY — 숨김은 편의)
                        if (supportRowLabel(record)) return <div />;
                        return (
                            <div class="manage-cell">
                                    <a-button
                                        onClick={() => {this.openModal(modalType.menu, record)}}
                                        shape="circle item-names"
                                        icon={<i class="fa-regular fa-pen-to-square" />}
                                    />
                                    {resetButton(record)}
                            </div>
                        )
                    },
                    title: ()=>{
                        return (
                            this.$t('manu_acc_list_manage')
                        )
                    }
                };
                const updateColumn = {
                    key: 'update-button', dataIndex: 'update-button', align: 'center', fixed: 'right',
                    customRender: ({text, record}) => {
                    if (supportRowLabel(record)) return <div />;
                    return (
                        <div style="width: 100%; display: flex; justify-content: center;">
                            <a-button 
                                shape="circle"
                                onClick={() => {this.openModal(modalType.update, record)}}
                                icon={<i class="fa-regular fa-pen-to-square" />}
                            />  
                        </div>
                    )
                    },
                    title: ()=>{
                        return (
                            this.$t('itemslist_table_modify')
                        )
                    }
                };
                const deleteColumn = {
                    key: 'delete-button', dataIndex: 'delete-button', align: 'center', fixed: 'right',
                    customRender: ({text, record}) => {
                    // 자기 행은 삭제 없음 — 지원 탭은 그 회사 최상위 관리자 행이 「자기 행」(대표와 같은 화면, utils/supportMaster)
                    if(masterCheckUsername(companyInfo['accountInfo']['username'], this.$store.state.privileges) === record.username || supportRowLabel(record)) {
                        return <div />
                    } else {
                        return (
                            <div style="width: 100%; display: flex; justify-content: center;">
                                <a-button 
                                    shape="circle"
                                    onClick={() => this.deleteAccount(record._id)}
                                    icon={<i class="fa-solid fa-trash-can" />}
                                />
                            </div>
                        )
                    }
                    },
                    title: ()=>{
                        return (
                                this.$t('itemslist_table_delete')
                        )
                    }
                }
                
                // 「권한」 버튼은 회사 관리자만, 수정·삭제는 privilege update/delete 에 따라 노출 (하드코딩 없음)
                if(this.isCompanyManager) this.columns.push(menuColumn);
                if(this.visibleUpdateAccountBtn) this.columns.push(updateColumn);
                if(this.visibleDeleteAccountBtn) this.columns.push(deleteColumn);
            },
            async openModal(type, param) {
                this.modal[type].show = true;
                if(param) this.modal.selectedItem = param;
            },
            async closeModal(type, value) {
                this.modal[type].show = value;
            },
            async deleteAccount(id) {
                const result = await confirmDialog('계정 삭제', '정말로 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.');
                if(!result) return;

                try {
                    const response = await this.$apiInstance.delete(`/accounts/other/${id}`);
                    if (response.status === 200 || response.status === 201) {
                        await oneBtnDialog('계정 삭제 성공', '계정을 삭제하였습니다.', false);
                        await this.getAccountsList();
                    }
                } catch(error) {
                    console.log(error);
                    await oneBtnDialog('계정 삭제 실패', '계정 삭제에 실패하였습니다.', false);
                }
            },
            async enter() {
                this.paginationData.currentPage = 1;
                await this.getAccountsList();
            },
            async paginationHandler(childPassParam) {
                this.paginationData.currentPage = childPassParam.page;
                await this.getAccountsList();
            },
            // 계정 리스트 가져오기
            async getAccountsList() {
                const params = {};
                if(this.previousCondition !== this.condition) {
                    params.page = 1;
                } else {
                    params.page = this.paginationData.currentPage;
                }
                params.limit = this.rowsPerPage;
                params.search = this.searchFilter;
                params.condition = this.condition;
                try {
                    const response = await this.$apiInstance.get(`/accounts/manufacturer`, { params });
                    if (response.status === 200 || response.status === 201) {
                        this.calledApiTimes ++;
                        if(this.previousCondition !== this.condition) {
                            this.paginationData.currentPage = 1;
                        } 
                        this.previousCondition = this.condition;
                        if(response.data.docs) {
                            this.responseData = response.data.docs;
                        } else {
                            this.responseData = [];
                        }
                        this.listSize = response.data.totalDocs;
                        for (let i = 0; i < this.responseData.length; i++) {
                            this.responseData[i].index = this.listSize - (this.paginationData.currentPage - 1) * this.rowsPerPage  - i;
                        }
                        this.paginationData.totalPages = response.data.totalPages;
                    }
                } catch (error) {
                    console.log(error);
                    await oneBtnDialog(this.$i18n.t('manu_acc_list_fail_title'), this.$i18n.t('manu_acc_list_fail_content'), false);
                }
            },
            handleDeviceInfoText(deviceInfoArray) {
                if(!Array.isArray(deviceInfoArray)) return this.$i18n.t('manu_acc_list_no_result');
                if(deviceInfoArray.length === 0) return this.$i18n.t('manu_acc_list_no_result');
                return this.$i18n.t('manu_acc_list_yes_result');
            },
            handleIsFirstLoginText(input) {
                switch(input) {
                    case 'Y':
                        return this.$i18n.t('manu_acc_list_no_login_result');
                    case 'N':
                        return this.$i18n.t('manu_acc_list_yes_login_result');
                }
            },
            handleIsErpText(input) {
                switch(input) {
                    case 'Y':
                    return 'ERP';
                    case 'N':
                    return this.$i18n.t('manu_acc_list_manually_added');
                }
            },

            // 페이지네이션
            async handleRowsPerPage() {
            this.paginationData.currentPage = 1;
            await this.getAccountsList();
            },
        },
    };
</script>
<style lang="scss" scoped>

@media screen and (max-width:767px) {
  .ant-select{
    width: 120px !important;
  }
  .button-wrap{
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .mobile-wrap {
    display: flex;
    align-items: flex-start;
    width: 100%;

    & > div {
      width: 100%;
    }

    .contract-item-input-wrap {
      display: flex;
      flex-direction: column;
    }
  }
  
  .search-filter-content .search-input-container{
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;
    input{
      width: 100%;
    }
  }
  .search-filter-row,
  .search-filter-content {
    height: auto;
    flex-direction: column;
    flex: none;
  }
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv{
    width: 100% !important;
  }
  .header-btn{
    margin-left: auto;
  }
  .CertListTitle {
      width: 100%;
    .d-flex.gap-2{
      width: 100%;
      flex-direction: column;
      button{
        width: 100%;
        word-break: keep-all;
        text-align: left;
      }
    }
  }
  .table-with-search .table-info-filter{
    flex-direction: column;
    align-items: flex-start;
    flex: none;
    justify-content: flex-start;
  }
  .table-with-search .search-container .search-div input,
  .table-with-search .search-container .search-div button{
    width: 60px !important;
    min-width: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .table-with-search .search-container .search-div input{
    width: calc(100% - 60px)!important;
  }
  #searchFilter{
    display: flex;
    flex-wrap: row;
  }
   .table-with-search .search-container,
   .table-with-search .search-container .search-div,
   .table-with-search .search-container select{
    width: 100%;
    flex: none;
   }
}

@media screen and (min-width:768px) and (max-width:1023px){
  .table-with-search .table-info-filter{
    flex-direction: column;
    width: 100%;
    .total-div{
      margin-right: auto;
    }
    .search-container{
      width: 100%;
      flex-direction: row;
      .search-div{
        flex-direction: row;
        width: 100%;
        input{
          width: calc(100% - 80px) !important;
        }
        .search-btn{
          min-width: 80px;
        }
      }
    }
  }
}

.button-wrap{
  width: 100%;
  display: flex;
  gap: 8px;
}
/* 회사 전체 2차 인증 필수 상태(표 위 안내 줄) */
.two-factor-status{
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 12px;
  font-size: 13px;
  color: #4b5158;
  i {
    color: #8d939a;
  }
}
/* 2차 인증 칸·이름 칸(로그인 잠김)·권한 관리 칸(표 칸은 :deep) */
:deep(.two-factor-cell),
:deep(.name-cell),
:deep(.manage-cell) {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
:deep(.manage-cell) {
  justify-content: center;
}
/* 1280 폭에서 표가 넘치지 않게(#14 재점검): 잠김 배지는 이름 아래, 생성일시는 날짜·시각 두 줄(표 칸은 white-space: pre),
   「2차 인증 초기화」는 아이콘 없이 글자만 */
:deep(.two-factor-cell),
:deep(.name-cell) {
  flex-direction: column;
  gap: 2px;
}
:deep(.name-cell) {
  align-items: flex-start;
}
:deep(.date-cell) {
  width: min-content;
  white-space: normal;
}
:deep(.two-factor-methods) {
  font-size: 12px;
  color: #6e747c;
}
/* 「2차 인증 초기화」: 검색칸 「초기화」(회색 면)와 다른 테두리 버튼(#15) */
:deep(.tf-reset-btn.ant-btn) {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #d1d6db;
  border-radius: 6px;
  background-color: #fff !important;
  color: #4b5158 !important;
  font-size: 12px;
  &:not(:disabled):hover {
    border-color: #8d939a;
    color: #17191c !important;
  }
  &:disabled {
    pointer-events: none;
    opacity: 0.45;
  }
}
:deep(.tf-reset-wrap) {
  display: inline-flex;
  cursor: not-allowed;
}
.search-filter-content{
  .mobile-wrap{
    display: flex;
    gap: 8px;
  }
  .mobile-no-wrap{
    display: flex;
  }
}
.noData{
    color: #acb2b9;
    font-size: 16px;
    margin: 20px;
}

input[type="text"] {
  height: 36px !important;
}
</style>